import { render, staticRenderFns } from "./AppBarProfile.vue?vue&type=template&id=77fa112a"
import script from "./AppBarProfile.vue?vue&type=script&lang=js"
export * from "./AppBarProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports